<template>
  <div class="auth">
    <ToAuth v-if="authOrConfig==='auth'" :authOrConfig.sync='authOrConfig'></ToAuth>
    <ConfigAuth v-else-if="authOrConfig==='configAuth'" :authInfo='authInfo' :authOrConfig.sync='authOrConfig' @backConfigRefresh='queryAuthStatus'></ConfigAuth>
    <div v-else>
      <div class="top">
        <div class="top-left">
          <div style="margin-bottom: 5px;" @click="selfSet(0,1)" class="leftimage">
            <img :src="authImgUrl"/>
            <span>{{authStatusText}}</span>
          </div>
          <div v-if="!this.authInfo||String(this.authInfo.type)===authStatus.NEED_AUTH" style="margin-top: 5px;" @click="selfSet()" class="leftimage">
            <img src="../../../../static/wx.png"/>
            <span>微信自定义设置</span>
          </div>
          <div v-else class="resetConfig" style="cursor:pointer" @click="resetConfig()">重置配置</div>
        </div>
        <div class="top-right">
          <div>微信授权</div>
          <p>为了保证您能正常使用平台所有功能，请</p>
          <p>使用已认证服务号进行微信公众授权完</p>
          <p>美对接微信公众号，搭建属于自己的公</p>
          <p>众平台，实现线下支付与线上引流相结合</p>
          <p>为商户提供统一的公众管理平台，包括自</p>
          <p>定义菜单、卡券、会员卡、等营销工具</p>
          <p>还没有公众号?&nbsp;&nbsp;&nbsp;<a
            href='https://mp.weixin.qq.com/cgi-bin/readtemplate?t=register/step1_tmpl&lang=zh_CN' target="_blank"
            style="color:#33cded">立即申请</a></p>
        </div>
      </div>
      <div class="bottom">
      <h2>公众号管理</h2>
      <div class="bottom-box">
        <div>
          <img src="../../../../static/auth1.jpg" alt="">
          <p>微信官方许可</p>
          <p>微信官方推出的小程序授权</p>
        </div>
        <div>
          <img src="../../../../static/auth2.jpg" alt="">
          <p>小程序免繁琐设置</p>
          <p>小程序运营不再需要理解繁琐参数设置</p>
        </div>
        <div>
          <img src="../../../../static/auth3.jpg" alt="">
          <p>安全可靠的授权</p>
          <p>机密数据传输，保证小程序安全</p>
        </div>
      </div>

    </div>
    </div>
  </div>

</template>

<script>
import ToAuth from './ToAuth'
import ConfigAuth from './ConfigAuth'
import api from '../../../config/api'
export default {
  data() {
    return {
      selfSet($type, type) {
        if ($type === 2) {
          //第三方授权
        } else {
          if (type) {
            console.log('微信授权信息');
            // this.authOrConfig='auth';
            switch (String(this.authInfo.type)) {
              case this.authStatus.PASSED_AUTH://已授权
                this.$confirm('您已经授权过公众号，是否要重复授权？', '温馨提示', {
                  confirmButtonText: '是',
                  cancelButtonText: '否',
                  type: 'info'
                }).then(() => {
                  let url=api.system.preauthcode;
                  this.$axios.fetchPost(url).then((res)=>{
                    if (200 === res.code) {
                      window.open(res.data, '_blank');
                    } else {

                    }
                  })
                }).catch(() => {
                });
                break;
              case this.authStatus.CONFIGED_WECHAT://微信已设置
                this.authOrConfig='configAuth';
                break;
              default://从未授权
                let url=api.system.preauthcode;
                this.$axios.fetchPost(url).then((res)=>{
                  if (200 === res.code) {
                    window.open(res.data, '_blank');
                  } else {

                  }
                })
                break;
            }
          } else {
            console.log('配置公众号');
            this.authOrConfig='configAuth';
          }
        }
      },
      authInfo:{},
      authImgUrl:'../../../../static/wx.png',
      authStatusText:'微信授权信息',
      authStatus:{
        NEED_AUTH:'0',//未授权公众号
        CONFIGED_WECHAT:'1',//微信已设置
        PASSED_AUTH:'2',//已授权公众号
      },
      authOrConfig:''//是授权页面还是配置页面
    }
  },
  components:{
    ToAuth,
    ConfigAuth
  },
  created() {
    //查询公共号授权状况
    this.queryAuthStatus();
  },
  methods: {
    resetConfig(){
      this.$confirm('公众号相关配置会被清空，是否继续重置配置？', '温馨提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'info'
      }).then(() => {
        let url=api.system.publicNumConfigReset;
        const loading=this.$loading();
        this.$axios.fetchPost(url).then((res)=>{
          loading.close();
          if(res.code===200){
            this.$notify({
              type: "success",
              title: '重置操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({
            //   message:'重置成功',
            //   type:'success'
            // })
            this.queryAuthStatus();
          }
        })
      }).catch(() => {
      });
    },
    queryAuthStatus(){
      const loading=this.$loading({lock:true});
      let url=api.system.publicNumAuthQuery;
      this.$axios.fetchPost(url).then((res)=>{
        loading.close();
        if(res.code===200){
          this.authInfo=res.data;
          if(res.data){
            switch (String(res.data.type)) {
              case this.authStatus.PASSED_AUTH://已授权相关
                this.authStatusText='微信已授权';
                this.authImgUrl=res.data.headImg;
                break;
              case this.authStatus.NEED_AUTH://未授权
                this.authStatusText='微信授权信息';
                this.authImgUrl='../../../../static/wx.png';
                break;
              case this.authStatus.CONFIGED_WECHAT://微信已设置
                this.authStatusText='微信已设置';
                this.authImgUrl='../../../../static/wx.png';
              default:

                break;
            }
          }else{
            this.authStatusText='微信授权信息';
          }
        }else{
          this.$notify({
            type: "error",
            title: '公众号授权状况查询',
            message: '失败',
            showClose: false,
          });
          // this.$message.error('公众号授权状况查询失败');
        }
      })
    }
  }
}
</script>

<style scoped>
.auth {
  width: 100%;
  position: relative;
}

.top-left {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-right: 1px solid #2ba1fc;
}

.auth .top {
  display: flex;
  height: 320px;
  width: 100%;
  align-items: center;
  justify-content: center;

}

.leftimage {
  margin-right: 40px;
  text-align: center;
  height: 90px;
  line-height: 80px;
  width: 310px;
  box-sizing: border-box;
  border: 3px dashed #2ba1fc;
  margin-bottom: 22px;
  cursor: pointer;
}

.leftimage img {
  width: 60px;
  vertical-align: middle;
  margin-right: 15px;
}

.leftimage h2 {
  display: inline;
  color: #2ba1fc;
  font-size: 20px;
  font-weight: 400;
}

.top-right {
  margin-left: 40px;
}

.top-right h2 {
  color: #2ba1fc;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 10px;
}

.top-right p {
  color: #666666;
  line-height: 25px;
}

.auth .bottom {
  border: 1px solid #2ba1fc;
  padding: 0 20px;
  width: 93%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.bottom h2 {
  font-weight: 500;
  color: #2ba1fc;
  width: 230px;
  background: rgba(242, 242, 242);
  text-align: center;
  position: absolute;
  left: 50%;
  top: -20px;
  transform: translateX(-50%);
}

.bottom-box {
  justify-content: space-around;
  display: flex;
  width: 100%;
  height: 220px;
  align-items: center;
}

.bottom-box div {
  flex-direction: column;
  align-items: center;
  display: flex;
  width: 240px;
  height: 150px;
}

.bottom-box div img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.bottom-box div p {
  color: #666666;
  line-height: 30px;
}

.bottom-box div p:nth-of-type(1) {
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/page/system/wechat/Auth.vue